export default "__VITE_ASSET__4OT6EJCc__"